import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AppState } from '../../../store/app.state';
import { Store } from '@ngrx/store';
import { selectIsAuthenticated } from '../../../store/auth/auth.selectors';
import { map, take } from 'rxjs';

export const authGuard = (): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store = inject(Store<AppState>);
    const router = inject(Router);

    return store.select(selectIsAuthenticated).pipe(
      take(1),
      map((isAuthenticated) => {
        console.log("isAuthenticated", isAuthenticated);

        if (!isAuthenticated) {
          router.navigate(['/login']);
          return false;
        }
        return true;
      })
    );
  };
};
